import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import BusinessEnergyPlan from "@/pages/BusinessEnergyPlan";
import Industries from "@/pages/Industries";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import ApplySuccess from "@/pages/ApplySuccess";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import PPADisclaimer from "@/pages/PPADisclaimer";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminApplicationDetail from "@/pages/admin/AdminApplicationDetail";
import AdminProposal from "@/pages/admin/AdminProposal";
import AdminEmailLog from "@/pages/admin/AdminEmailLog";
import AdminGreenAdvisor from "@/pages/admin/AdminGreenAdvisor";
import AdminNmiAnalysis from "@/pages/admin/AdminNmiAnalysis";
import ProposalPublic from "@/pages/ProposalPublic";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/business-energy-plan" element={<BusinessEnergyPlan />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/ppa-disclaimer" element={<PPADisclaimer />} />
          </Route>

          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/success" element={<ApplySuccess />} />

          <Route path="/proposal/:token" element={<ProposalPublic />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="applications" element={<AdminDashboard />} />
            <Route path="applications/:id" element={<AdminApplicationDetail />} />
            <Route path="applications/:id/proposal" element={<AdminProposal />} />
            <Route path="applications/:id/nmi-analysis" element={<AdminNmiAnalysis />} />
            <Route path="emails" element={<AdminEmailLog />} />
            <Route path="green-advisor" element={<AdminGreenAdvisor />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
